package com.ervasstudio.tracoemovimento.model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BlogPost(
    @SerialName("_ID")
    val id: Int, // O JetEngine CCT costuma usar _id

    @SerialName("titulo")
    val titulo: String,

    @SerialName("cct_author_id")
    val id_autor: String? = null,

    @SerialName("corpo")
    val corpo: String? = null,


    @SerialName("cct_status")
    val status: String? = null,

    @SerialName("ultima_actualizacao")
    val cct_modified: String? = null,


    @SerialName("subtitulo")
    val subtitulo: String? = null,


    @SerialName("cct_created")
    val dateCreated: String? = null,

    @SerialName("heroshoot")
    val heroshoot: String? = null,

    @SerialName("galeria")
    val galeria: String? = null,

    @SerialName("data_evento")
    val data_evento: String? = null,

    @SerialName("destacado")
    val destacado: String? = null,

    @SerialName("cct_slug")
    val slug: String? = null

){
    val listaDeFotos: List<Foto>
        get() {
            if (galeria.isNullOrBlank()) return emptyList()

            return galeria.split(",")
                .map { it.trim() } // Remove espaços em branco acidentais nas pontas
                .filter { it.isNotEmpty() } // Ignora itens vazios
                .map { url -> Foto(url) } // Transforma a String da URL no seu objeto Foto
        }

    val dataFormatada: String
        get() {
            if (data_evento.isNullOrBlank()) return ""

            return try {
                // Divide a data "2026-06-10" em ["2026", "06", "10"]
                val partes = data_evento.split("-")
                if (partes.size != 3) return data_evento

                val ano = partes[0]
                val mesNumero = partes[1].toInt()
                val dia = partes[2].toInt() // Converte para Int para remover zeros à esquerda (ex: "06" vira "6")

                val meses = listOf(
                    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
                )

                val mesNome = meses[mesNumero - 1]

                "$dia de $mesNome de $ano"
            } catch (e: Exception) {
                data_evento
            }
        }
}